/** In-app paths shared by the router, the sidebar and links. */
export const KNOWLEDGE_HUB_PATH = '/knowledge-hub'
export const TRIPS_PATH = `${KNOWLEDGE_HUB_PATH}/trips`
export const SOLUTIONS_LIBRARY_PATH = `${KNOWLEDGE_HUB_PATH}/solutions`
export const L3OS_SYNC_PATH = '/l3os-center'

/** The OS page for one solution, by kb uuid or Notion page id. */
export const solutionPath = (id: string) =>
  `/solutions/${encodeURIComponent(id)}`
